<template>
    <div>
        <b-sidebar aria-labelledby="sidebar-no-header-title" no-header id="viewQuotation" backdrop style="direction:ltr" width="90%" right :title="lang.add_pay_type" shadow >
            <template #default="{ hide }">
                <div class="m-1 text-start" style="direction:rtl">
                    <div style="width:120px;margin-right:10px;background:#000;color:#FFF;border-radius:5px" class="btn-primary btn-sm text-center">
                    <span>{{lang.view_quotation}}</span>
                    </div>
                    <div @click="hide" id="closeaddpayment" style="width:100px;text-align:center;float:left;margin-left:5px;margin-top:-25px;cursor:pointer" class="btn-danger btn-sm closethis">
                    <span>{{lang.close}}</span>
                </div>
                </div>
                <v-divider></v-divider>
                <div class="m-2" style="direction:rtl">

                    <v-row :style="`margin:auto;width:100%;direction:rtl;text-align:right`">
                        <v-col cols="12" :style="`direction:`+lang.dir+`;text-align:`+lang.algin+`;`" v-if="$store.state.licenseType.activemenu != 'smallif' || $store.state.group_id != 3">
                            <div class="tobbuttom backBlack" style="padding:1px;width:100%;text-align:center;gap: 3px;">
                                <b-button class="mytab1 btn btn-sm btn-success m-2" style="background:darkblue !important;border:2px solid #fff !important;font-size:1.1rem !important;width:130px;" v-b-toggle.add_quotation @click="updateMe()" v-if="quot.status == 1">{{lang.update}}</b-button>
                                <b-button class="mytab1 btn btn-sm btn-success m-2" style="background:darkblue !important;border:2px solid #fff !important;font-size:1.1rem !important;width:130px;" @click="printPDF()">{{lang.printQuot}}</b-button>
                                <b-button class="mytab1 btn btn-sm btn-success m-2" style="background:blue !important;border:2px solid #fff !important;font-size:1.1rem !important;width:130px;" @click="printQuot()">{{lang.view_quot_pdf}}</b-button>
                                <b-button style="border:2px solid #fff !important;font-size:1.1rem !important;background:black !important;;width:155px;" @click="doAddJobCard()" v-if="quot.status == 1 && $store.state.licenseType.isCar" class="mytab2 btn btn-sm btn-primary m-2" v-b-toggle.add_new_card>{{lang.add_new_card}}</b-button>
                                <b-button style="border:2px solid #fff !important;font-size:1.1rem !important;background:green !important;;width:120px;" @click="doAddInv()" v-if="quot.status == 1 && $store.state.licenseType.showInvoiceList" class="mytab2 btn btn-sm btn-primary m-2" v-b-toggle.add_invoice>{{lang.convert_to_invoice}}</b-button>
                                <!-- <b-button style="border:2px solid #fff !important;font-size:1.1rem !important;background:dargreen !important;;width:120px;" @click="doAddInv()" v-if="quot.status == 1" class="mytab2 btn btn-sm btn-primary m-2" v-b-toggle.add_invoice>{{lang.add_contract}}</b-button>  -->
                                <b-button style="border:2px solid #fff !important;font-size:1.1rem !important;background:red !important;width:120px;" class="mytab2 btn btn-sm btn-danger m-2" v-if="quot.status == 1" @click="updateQuot(3)" v-b-toggle.returnInvoice>{{lang.cancel_quto}}</b-button>
                                <b-button style="border:2px solid #fff !important;font-size:1.1rem !important;background:red !important;width:120px;" class="mytab2 btn btn-sm btn-danger m-2" v-if="quot.status == 3" @click="updateQuot(1)" v-b-toggle.returnInvoice>{{lang.return_quotation}}</b-button>
                                <b-button style="border:2px solid #fff !important;font-size:1.1rem !important;background:red !important;width:120px;" class="mytab2 btn btn-sm btn-danger m-2" v-if="$store.state.licenseType.showDeliveryNote" @click="printDelivery()">{{lang.delivery_note}}</b-button>
                                <b-button style="border:2px solid #fff !important;font-size:1.1rem !important;background:red !important;width:120px;" class="mytab2 btn btn-sm btn-danger m-2"  v-if="quot.status == 1" @click="sign_quotation()">{{lang.sign_quotation}}</b-button>
                                <b-button style="border:2px solid #fff !important;font-size:1.1rem !important;background:red !important;width:120px;" class="mytab2 btn btn-sm btn-danger m-2"  v-if="quot.status == 1" @click="deleteQuot()">{{lang.delete}}</b-button>
                                <img :src="`../../whatsappicon.png`" v-b-toggle.send_client_whats  style="border:2px solid #fff !important;font-size:1.1rem !important;width:120px;margin-inline-start: 10px;height: 38px;border-radius: 5px;cursor:pointer" @click="openWhatsAPP()" />
                            </div>
                        </v-col>
                        <v-col cols="12" :style="`direction:`+lang.dir+`;text-align:`+lang.algin+`;`" v-if="$store.state.licenseType.activemenu == 'smallif' && $store.state.group_id == 3">
                            <div class="tobbuttom backBlack" style="padding:1px;width:100%;text-align:center;">
                                <b-button class="mytab1 btn btn-sm btn-success m-2" style="background:darkblue !important;border:2px solid #fff !important;font-size:1.1rem !important;width:130px;" v-b-toggle.add_quotation @click="updateMe()" v-if="quot.status == 1">{{lang.update}}</b-button>
                                <b-button class="mytab1 btn btn-sm btn-success m-2" style="background:darkblue !important;border:2px solid #fff !important;font-size:1.1rem !important;width:130px;" @click="printPDF()">{{lang.printQuot}}</b-button>
                                <b-button class="mytab1 btn btn-sm btn-success m-2" style="background:blue !important;border:2px solid #fff !important;font-size:1.1rem !important;width:130px;" @click="printQuot()">{{lang.view_quot_pdf}}</b-button>
                                <b-button style="border:2px solid #fff !important;font-size:1.1rem !important;background:red !important;width:120px;" class="mytab2 btn btn-sm btn-danger m-2" v-if="quot.status == 1" @click="updateQuot(3)" v-b-toggle.returnInvoice>{{lang.cancel_quto}}</b-button>
                                <img :src="`../../whatsappicon.png`" v-b-toggle.send_client_whats  style="border:2px solid #fff !important;font-size:1.1rem !important;width:120px;margin-inline-start: 10px;height: 38px;border-radius: 5px;cursor:pointer" @click="openWhatsAPP()" />
                            </div>
                        </v-col>
                        <v-col cols="12" :style="`overflow-x: auto;direction:`+lang.dir+`;text-align:`+lang.algin+`;`" >
                            <b-table-simple class="m-2" style="width:98%;margin:auto">
                                <tbody>
                                    <tr>
                                        <th style="white-space: nowrap;border:1px solid #555;text-align:center;background:#000;color:#FFF;border-bottom:1px solid #fff !important">{{lang.quotnumber}}</th>
                                        <td style="border:1px solid #555;text-align:center;">{{ quot.quot_number }}</td>
                                        <th style="white-space: nowrap;border:1px solid #555;text-align:center;background:#000;color:#FFF;border-bottom:1px solid #fff !important">{{lang.quot_date}}</th>
                                        <td style="border:1px solid #555;text-align:center;">{{ quot._quot_date }}</td>
                                        <th style="white-space: nowrap;border:1px solid #555;text-align:center;background:#000;color:#FFF;border-bottom:1px solid #fff !important">{{lang.bid_number}}</th>
                                        <td style="border:1px solid #555;text-align:center;">{{ quot.bid_number }}</td>
                                        <th style="white-space: nowrap;border:1px solid #555;text-align:center;background:#000;color:#FFF;border-bottom:1px solid #fff !important">{{lang.status}}</th>
                                        <td style="border:1px solid #555;text-align:center;">{{ quot._status }}</td>
                                    </tr>
                                    <tr>
                                        <th style="white-space: nowrap;border:1px solid #555;text-align:center;background:#000;color:#FFF;border-bottom:1px solid #fff !important">{{lang.mobile}}</th>
                                        <td style="border:1px solid #555;text-align:center;">{{ quot.mobile }}</td>
                                        <th style="white-space: nowrap;border:1px solid #555;text-align:center;background:#000;color:#FFF;border-bottom:1px solid #fff !important">{{lang.customer_name}}</th>
                                        <td style="border:1px solid #555;text-align:center;">{{ quot.full_name }}</td>
                                        <th style="white-space: nowrap;border:1px solid #555;text-align:center;background:#000;color:#FFF;border-bottom:1px solid #fff !important">{{lang.company_name}}</th>
                                        <td style="border:1px solid #555;text-align:center;">{{ quot.company_name }}{{ quot.entity_name }}</td>
                                        <th style="white-space: nowrap;border:1px solid #555;text-align:center;background:#000;color:#FFF;border-bottom:1px solid #fff !important">{{lang.branch_name}}</th>
                                        <td style="border:1px solid #555;text-align:center;">{{ quot.branch_name }}</td>
                                    </tr>

                                    <tr>
                                        <th style="white-space: nowrap;border:1px solid #555;text-align:center;background:#000;color:#FFF;border-bottom:1px solid #fff !important">{{lang.po_date}}</th>
                                        <td style="border:1px solid #555;text-align:center;">{{ quot.po_date }}</td>
                                        <th style="white-space: nowrap;border:1px solid #555;text-align:center;background:#000;color:#FFF;border-bottom:1px solid #fff !important">{{lang.po_number}}</th>
                                        <td style="border:1px solid #555;text-align:center;">{{ quot.po_number }}</td>
                                        <th style="white-space: nowrap;border:1px solid #555;text-align:center;background:#000;color:#FFF;border-bottom:1px solid #fff !important">{{lang.afforded_customer_name}}</th>
                                        <td style="border:1px solid #555;text-align:center;">{{ quot.customer_name }}</td>
                                        <th style="white-space: nowrap;border:1px solid #555;text-align:center;background:#000;color:#FFF;border-bottom:1px solid #fff !important">{{lang.customer_afforded}}</th>
                                        <td style="border:1px solid #555;text-align:center;">{{ quot.customer_afforded }}</td>
                                    </tr>
                                    <tr>
                                        <th style="white-space: nowrap;border:1px solid #555;text-align:center;background:#000;color:#FFF;border-bottom:1px solid #fff !important">{{lang.invoice_class}}</th>
                                        <td style="border:1px solid #555;text-align:center;" colspan="7">{{ quot._user_invtype }}</td>
                                    </tr>

                                </tbody>
                                <tfoot v-if="$store.state.licenseType.cars || $store.state.licenseType.carinfo">
                                    <tr v-for="(item,index) in ecars" :key="index">
                                        <th class="backBlack" style="border:1px solid #555;text-align:center;background:#000;color:#FFF;border-bottom:1px solid #fff !important">{{lang.plate_number}}</th>
                                        <td style="border:1px solid #555;text-align:center;">{{ item.plate_number }}</td>
                                        <th class="backBlack" style="border:1px solid #555;text-align:center;background:#000;color:#FFF;border-bottom:1px solid #fff !important">{{lang.model}}</th>
                                        <td style="border:1px solid #555;text-align:center;">{{ item.model }}</td>
                                        <th class="backBlack" style="border:1px solid #555;text-align:center;background:#000;color:#FFF;border-bottom:1px solid #fff !important">{{lang.car_color}}</th>
                                        <td style="border:1px solid #555;text-align:center;">{{ item.color }}</td>
                                        <th class="backBlack" style="border:1px solid #555;text-align:center;background:#000 !important;color:#FFF;border-bottom:1px solid #fff !important">{{lang.car_year}}</th>
                                        <td style="border:1px solid #555;text-align:center;">{{ item.made_year }}</td>
                                    </tr>
                                </tfoot>
                            </b-table-simple>
                        </v-col>
                    </v-row>
                    <v-row style="overflow-x: auto;margin:auto;width:100%">
                        <v-col cols="12" md="3" sm="6" class="px-0">
                            <label>{{lang.chose_from_list}} {{lang.vat_type}}</label>
                            <b-input-group>
                                <b-form-select
                                    class="selborder"
                                    v-model="invoice.vtype"
                                    :options="vatTypes"
                                    @change="calckIt()"
                                ></b-form-select>
                                <b-input-group-append style="margin-right:-20px;margin-top:5px;">
                                    <i class="fas fa-arrow-down"></i>
                                </b-input-group-append>
                            </b-input-group>
                        </v-col>
                        <h6 style="width:100%;margin-top:12px;">{{lang.quotation_details}}</h6>
                        <b-table-simple class="m-2" style="width:98%;margin:auto">
                            <thead>
                                <tr>
                                    <th class="backBlack" style="text-align:center;" v-if="$store.state.licenseType.showCarPlate">{{lang.plate_number}}</th>
                                    <th class="backBlack" style="text-align:center;">{{lang.item_code}}</th>
                                    <th class="backBlack" style="text-align:center;">{{lang.description}}</th>
                                    <th class="backBlack" style="text-align:center;">{{lang.qtty}}</th>
                                    <th class="backBlack" style="text-align:center;">{{lang.item_price}}</th>
                                    <th class="backBlack" style="text-align:center;">{{lang.discount}} %</th>
                                    <th class="backBlack" style="text-align:center;">{{lang.discount}}</th>
                                    <th class="backBlack" style="text-align:center;">{{lang.total}}</th>
                                    <th class="backBlack" style="text-align:center;">{{lang.vat}} 15%</th>
                                    <th class="backBlack" style="text-align:center;">{{lang.ftotal}}</th>
                                    <th class="backBlack" style="text-align:center;">{{lang.action}}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item,index) in quot.rows" :key="index">
                                    <td style="text-align:center;width:120px;" v-if="$store.state.licenseType.showCarPlate">{{item.plate_number}}</td>
                                    <td style="text-align:center;">{{item.itemcode}}</td>
                                    <td style="white-space: nowrap;text-align:center;width:200px;">{{item.item_name}}<br>{{item.description}}</td>
                                    <td style="text-align:center;">{{item.qty}}</td>
                                    <td style="text-align:center;">{{item.item_price}}</td>
                                    <td style="text-align:center;">{{item.perDisc}}</td>
                                    <td style="text-align:center;">{{item.discount}}</td>
                                    <td style="text-align:center;">{{item.total}}</td>
                                    <td style="text-align:center;">{{item.vat}}</td>
                                    <td style="text-align:center;">{{item.ftotal}}</td>
                                    <td style="text-align:center;">
                                        <b-button class="btn-sm btn-danger" style="width:70px;height:35px;" @click="delet(item.id)" v-if="quot.status == 1">{{lang.delete}}</b-button>
                                    </td>
                                </tr>
                                <tr v-if="quot.status == 1">
                                    <td v-if="$store.state.licenseType.showCarPlate">
                                        <b-input-group>
                                            <b-form-select class="selborder" v-model="newrow.plate_number" :options="carsinfo" />
                                            <b-input-group-append style="margin-right:-20px;margin-top:5px;">
                                                <i class="fas fa-arrow-down"></i>
                                            </b-input-group-append>
                                        </b-input-group>
                                    </td>
                                    <td>
                                        <v-text-field
                                            v-model="newrow.itemcode"
                                        ></v-text-field>
                                    </td>
                                    <td>
                                        <b-form-input v-model="newrow.item_name" list="items-list" @change="changeMe()"></b-form-input>
                                        <datalist id="items-list">
                                            <option v-for="(item,index) in itemsworkdes" :key="index">{{item.item_code}} -||- {{ item[`item_name${$parent.lang.langname}`] }}</option>
                                        </datalist>
                                    </td>
                                    <td>
                                        <v-text-field
                                            v-model="newrow.qty"
                                            @change="calckIt()"
                                        ></v-text-field>
                                    </td>
                                    <td>
                                        <v-text-field
                                            v-model="newrow.item_price"
                                            @change="calckIt()"
                                        ></v-text-field>
                                    </td>
                                    <td>

                                    </td>
                                    <td>
                                        <v-text-field
                                            v-model="newrow.discount"
                                            @change="calckIt()"
                                        ></v-text-field>
                                    </td>
                                    <td>
                                        <v-text-field
                                            v-model="newrow.total"
                                            readonly
                                        ></v-text-field>
                                    </td>
                                    <td>
                                        <v-text-field
                                            v-model="newrow.vat"
                                            readonly
                                        ></v-text-field>
                                    </td>
                                    <td>
                                        <v-text-field
                                            v-model="newrow.ftotal"
                                            readonly
                                        ></v-text-field>
                                    </td>
                                    <td>
                                        <b-button type="button" style="width:70px;height:35px" variant="success" class="btn-sm" @click="addNewRow()">{{lang.add}}</b-button>
                                    </td>
                                </tr>
                            </tbody>
                        </b-table-simple>
                        <b-table-simple :style="`width:400px;margin-`+lang.algin+`:17px;margin-`+lang.lalgin+`:auto;`">
                            <thead>
                                <tr>
                                    <th :class="`text-`+lang.lalgin+` backBlack`">{{lang.total_exclusive_vat}}</th>
                                    <td style="width:25%;border:1px solid #ccc;text-align:center;">{{fulltotals.total}}</td>
                                </tr>
                                <tr>
                                    <th :class="`text-`+lang.lalgin+` backBlack`">{{lang.vat}} 15%</th>
                                    <td style="width:25%;border:1px solid #ccc;text-align:center;">{{fulltotals.vat}}</td>
                                </tr>
                                <tr>
                                    <th :class="`text-`+lang.lalgin+` backBlack`">{{lang.ftotal}}</th>
                                    <td style="width:25%;border:1px solid #ccc;text-align:center;">{{fulltotals.ftotal}}</td>
                                </tr>
                            </thead>
                        </b-table-simple>
                    </v-row>
                    <div class="myRof" v-if="$store.state.licenseType.showSketch">
                        <div style="width:20%" v-for="(item,index) in quot.images" :key="index">
                            <div class="backBlack text-center">{{ item.plate }}</div>
                            <div>
                                <img :src="`${item.image}`" style="width:100%" />
                            </div>
                        </div>
                    </div>
                    <addInvoice ref="addInvo" />
                    <sendClientWhats ref="sendClientWhats" />
                    <addNewCard ref="addNewCard" />
                </div>
            </template>
        </b-sidebar>
    </div>
</template>

<script>
import axios from 'axios'
import addInvoice from '@/components/addInvoiceQu.vue'
import sendClientWhats from '@/components/sendClientWhats.vue';
import addNewCard from '@/components/addNewCard.vue';
export default{
    components: {
        addInvoice,sendClientWhats,addNewCard
    },
    data() {
        return {
            showme: false,
            quotid: 0,
            quot: {
                status: 0,
                rows: [],
                images: []
            },
            invoice: {
                vtype: 3,
            },
            newrow:{
                itemcode: '',
                item_name: '',
                qty: 1,
                item_price: '',
                total: 0,
                vat: 0,
                ftotal: 0,
                plate_number: '',
                discount: ''
            },
            carsinfo: [],
            itemsworkdes: []
        }
    },
    computed: {
        lang: function(){
            if(this.$cookies.get(this.$store.state.LangCooki) != null){
                if(this.$cookies.get(this.$store.state.LangCooki)  == 'en'){
                    return this.$store.state.lang.en;
                }else if(this.$cookies.get(this.$store.state.LangCooki)  == 'ur'){
                    return this.$store.state.lang.ur;
                }else{
                    return this.$store.state.lang.ar;
                }
            }
            else if(this.$store.state.deflang == 'en'){
                return this.$store.state.lang.en;
            }
            else if(this.$store.state.deflang == 'ur'){
                return this.$store.state.lang.ur;
            }else{
                return this.$store.state.lang.ar;
            }
        },
        ldir: function(){
            return this.lang.ldir;
        },
        lalgin: function(){
            return this.lang.lalgin;
        },
        items: function(){
            return {
                text: this.lang.quotations,
                disabled: true,
                href: '/view-quot',
            }
        },
        vatTypes: function(){
            return [
                {
                    text: this.lang.prices_include_vat,
                    value: 3,
                },
                {
                    text: this.lang.prices_exclusive_vat,
                    value: 2,
                },
                {
                    text: this.lang.prices_without_vat,
                    value: 1,
                },
            ]
        },
        ecars: function(){
            // // console.log("this is cars",this. quot.cars);
            return this.quot.cars;
        },
        fulltotals: function(){
            let t = {
                total: 0,
                ftotal: 0,
                vat: 0
            }

            for(let i=0;i<this.quot.rows.length;i++){
                t.total = this.$RoundNums(parseFloat(this.quot.rows[i].total) + parseFloat(t.total));
                t.ftotal = this.$RoundNums(parseFloat(this.quot.rows[i].ftotal) + parseFloat(t.ftotal));
                t.vat = this.$RoundNums(parseFloat(this.quot.rows[i].vat) + parseFloat(t.vat));
            }
            return t;
        }
    },
    methods: {
        deleteQuot() {
            const post = new FormData();
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append("type" , "delteQuot");
            post.append('auth',this.$cookies.get(this.$COOKIEPhase));
            post.append('data[id]',this.quotid)
            axios.post(
                this.$SAMCOTEC.r_path, post
            ).then((resposne) => {
                document.getElementById('closeaddpayment').click();
                this.$parent.getQuotations()
            });
        },
        sign_quotation(){
            window.open(`../api/signDoc.php?type=quot&id=${this.quotid}`, '_blank')
        },
        updateMe(){
            if(this.quotid == 0) return false;
            // console.log(this.$parent.$refs.addQuot);
            this.$parent.$refs.addQuot.getQuotation(this.quotid)
        },
        changeMe(){
            // console.log(this.newrow)
            const itemn = this.newrow.item_name.split(" -||- ");
            if(itemn.length > 1){
                this.newrow.itemcode = itemn[0];
                this.getItem();
            }
        },
        getItem(){
            const post = new FormData();
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append("type" , "getProducts");
            post.append('auth',this.$cookies.get(this.$COOKIEPhase));
            post.append('data[itemcode]',this.newrow.itemcode)
            axios.post(
                this.$SAMCOTEC.r_path, post
            ).then((resposne) => {
                if(resposne.data.results.data.length != 0){
                    this.newrow = {
                        itemcode: resposne.data.results.data[0].item_code,
                        description: resposne.data.results.data[0].description,
                        item_name: resposne.data.results.data[0][`item_name${this.lang.langname}`],
                        qty: 1,
                        item_price: resposne.data.results.data[0].default_price,
                        total: 0,
                        vat: 0,
                        ftotal: 0,
                        plate_number: '',
                        discount: resposne.data.results.data[0].discount
                    }
                    this.calckIt()
                }
            });
        },
        calckIt(index){
            //const row = this.quot.rows[index];
            let t = 0;
            let pr = 0;
            let item_price = this.newrow.item_price == '' ? 0 : this.newrow.item_price;
            let discount = this.newrow.discount == '' ? 0 : this.newrow.discount;
            if(!this.$store.state.licenseType.rowDiscountInTotal){
                pr = parseFloat(item_price) - parseFloat(discount)
                t = parseFloat(this.newrow.qty) * parseFloat(pr);
            }else{
                pr = parseFloat(item_price) * parseFloat(this.newrow.qty) - parseFloat(discount)
                t = pr;
            }

            if(!Number.isFinite(t) || t < 0){
                t = 0;
            }

            const trs = this.$calcVat(t, Number(this.invoice.vtype || this.quot.vtype || 3));
            this.newrow.total = this.$RoundNums(trs.tot,2);
            this.newrow.vat = this.$RoundNums(trs.vat,2);
            this.newrow.ftotal = this.$RoundNums(trs.ftot,2);
        },
        openWhatsAPP2(){
            const mobile = this.quot.mobile.substring(1);

            window.open("https://wa.me/966"+mobile,"_blank");
        },
        openWhatsAPP(){
            this.$refs.sendClientWhats.number_list = this.customer.mobile
            this.$refs.sendClientWhats.getOldMessages();
        },
        updateQuot(status){
            const post = new FormData();
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append("type" , "updateQuot");
            post.append('auth',this.$cookies.get(this.$COOKIEPhase));
            post.append("data[id]",this.quotid);
            post.append("data[status]",status);
            axios.post(
                this.$SAMCOTEC.r_path, post
            ).then((resposne) => {
                // // console.log(resposne.data)
                this.$parent.getQuotations()
            })
        },
        doAddJobCard()
        {
            this.$refs.addNewCard.quotationId = this.quot.id
            this.$refs.addNewCard.getQuotations();
        },
        async doAddInv() {
            await this.$refs.addInvo.convTo(this.quot);

            // this.$refs.addInvo.invoice.vtype = this.quot.vtype
            // this.$refs.addInvo.invoice.notes = this.quot.notes
            // this.$refs.addInvo.invoice.card_type = this.quot.card_type
            // this.$refs.addInvo.quotID = this.quot.id;
            // this.$refs.addInvo.customer.mobile = this.quot.mobile;
            // this.$refs.addInvo.getName();
            // this.$refs.addInvo.changeCusType(parseInt(this.quot.customer_type) - 1);
            // this.$refs.addInvo.tbrows = this.quot.rows;

            // this.$refs.addInvo.changeCoData({
            //     address: this.quot.address,
            //     branch_name: this.quot.branch_name,
            //     company_name: this.quot.company_name,
            //     entity_name: this.quot.entity_name,
            //     vatid: this.quot.vatid,
            //     crt_number: this.quot.crt_number,
            // });
            // this.$refs.addInvo.cars = this.quot.cars;
            // this.$refs.addInvo.ecars = this.quot.cars;
            // // this.$refs.addInvo.calcAll();
            // this.$refs.addInvo.company.cctype = this.quot.customer_type;
            // this.$refs.addInvo.changeVatType();

        },
        printQuot(){
            window.open('../../api/print.php?quotid='+this.quotid,'_blank');
        },
        printDelivery(){
            window.open('../../api/print.php?dquotid='+this.quotid,'_blank');
        },
        delet(id){
            const post = new FormData();
            post.append('defBranch',localStorage.getItem('defBranch'));
          post.append('financeYear',localStorage.getItem('financeYear'));
            post.append('type', "deleteQuotationRows");
            post.append('auth',this.$cookies.get(this.$store.state.COOKIEPhase))
            post.append('data[quotid]',this.quotid)
            post.append('data[id]',id)
            axios.post(
                this.$store.state.SAMCOTEC.r_path , post
            ).then((response) => {
                // console.log(response.data)
                this.getQuotations()
            })
        },
        addNewRow(){
            const post = new FormData();
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append('type', "updateQuotationRows");
            post.append('auth',this.$cookies.get(this.$store.state.COOKIEPhase))
            post.append('data[id]',this.quotid)
            post.append('data[vtype]',this.invoice.vtype)
            post.append('data[newrow][plate_number]',this.newrow.plate_number)
            post.append('data[newrow][itemcode]',this.newrow.itemcode)
            post.append('data[newrow][item_name]',this.newrow.item_name)
            post.append('data[newrow][qty]',this.newrow.qty)
            post.append('data[newrow][item_price]',this.newrow.item_price == '' ? 0 : this.newrow.item_price);
            post.append('data[newrow][total]',this.newrow.total);
            post.append('data[newrow][vat]',this.newrow.vat);
            post.append('data[newrow][ftotal]',this.newrow.ftotal);
            post.append('data[newrow][discount]',this.newrow.discount == '' ? 0 : this.newrow.discount);
            axios.post(
                this.$store.state.SAMCOTEC.r_path , post
            ).then(() => {
                this.getQuotations()
            })
        },
        getQuotations() {

            const post = new FormData();
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append('type', "getQuotations");
            post.append('auth',this.$cookies.get(this.$store.state.COOKIEPhase))
            post.append('data[id]',this.quotid)
            post.append('data[status]',0)
            // // console.log(this.quot);

            axios.post(
                this.$store.state.SAMCOTEC.r_path , post
            ).then((response) => {
                const res = response.data;
                // // console.log("this is the quotation ",res);
                this.quot = res.results.data[0];
                this.invoice.vtype = Number(this.quot.vtype || 3);
                this.carsinfo = []
                console.log("this.quot",this.quot)
                for(let i=0;i<this.quot.cars.length;i++){
                    this.carsinfo.push({text: this.quot.cars[i].plate_number,value: this.quot.cars[i].plate_number})
                    this.newrow.plate_number = this.quot.cars[0].plate_number
                }
                this.newrow.itemcode = ''
                this.newrow.item_name = ''
                this.newrow.qty = 1
                this.newrow.item_price = ''
                this.newrow.discount = ''
                this.calckIt()
            })

        },
        getInvSettings() {
            const post = new FormData();
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append('type','getInvSettings');
            post.append('auth',this.$cookies.get(this.$COOKIEPhase));
            post.append('data[all]','all');
            axios.post(
                this.$SAMCOTEC.r_path, post
            ).then(
                (response) => {
                    const res = response.data;
                    if(res != '' && res.error.number == 200){
                        if(res.results.data.users.length != 0){
                            for(let i= 0; i < res.results.data.users.length; i++){
                                this.invoice.users.push({
                                    text: res.results.data.users[i].full_name,
                                    value: res.results.data.users[i].id
                                })
                            }
                        }
                        if(res.results.data.products.length != 0){
                            this.itemsworkdes = [];
                            // this.allProducts = res.results.data;
                            this.itemsworkdes = res.results.data.products;

                            // for(let i= 0; i < res.results.data.products.length; i++){
                            //    this.itemsworkdes.push(res.results.products[i].name);
                            // }
                        }
                    }
                }
            )
        },
        printPDF ()
        {
            let pdfFrame = document.body.appendChild(document.createElement('iframe'));
            pdfFrame.style.display = 'none';
            pdfFrame.onload = () => (void pdfFrame.contentWindow.print());
            pdfFrame.src = '../../api/print.php?quotid='+this.quotid;
        },
    },
    created(){
        this.getInvSettings();
    }
}
</script>
<style>
.myRof{
    display:flex;
    flex-direction: row;
    justify-content: center;
    justify-items:center;
    align-items: center;
}
@media screen and (max-width: 1100px){
    .shoMobile {
        display: flex;
        flex-direction: column;
        gap: 5px;
    }
}
</style>